import React from 'react';
import styled from 'styled-components';

export type ChainFilter = 'ink' | 'eth' | 'wlfi' | 'mon' | 'sol';

interface ChainToggleProps {
  selectedChain: ChainFilter;
  onChainChange: (chain: ChainFilter) => void;
}

const ToggleContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 4px;
  backdrop-filter: blur(10px);
`;

const ChainButton = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: ${props => props.$active 
    ? 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)' 
    : 'transparent'};
  color: ${props => props.$active ? '#ffffff' : 'rgba(255, 255, 255, 0.6)'};
  font-size: 13px;
  font-weight: ${props => props.$active ? '600' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-family: 'Plus Jakarta Sans', sans-serif;
  
  &:hover {
    background: ${props => props.$active 
      ? 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)' 
      : 'rgba(255, 255, 255, 0.1)'};
    color: ${props => props.$active ? '#ffffff' : 'rgba(255, 255, 255, 0.8)'};
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`;

const ChainToggle: React.FC<ChainToggleProps> = ({ selectedChain, onChainChange }) => {
  const chains: { value: ChainFilter; label: string }[] = [
    { value: 'ink', label: 'Ink' },
    { value: 'eth', label: 'ETH' },
    { value: 'wlfi', label: 'WLFI' },
    { value: 'mon', label: 'MON' },
    { value: 'sol', label: 'SOL' },
  ];

  return (
    <ToggleContainer>
      {chains.map((chain) => (
        <ChainButton
          key={chain.value}
          $active={selectedChain === chain.value}
          onClick={() => onChainChange(chain.value)}
        >
          {chain.label}
        </ChainButton>
      ))}
    </ToggleContainer>
  );
};

export default ChainToggle;

